import { forwardRef } from "react";
import PropTypes from "prop-types";
import { getLabelClasses } from "@/helper/input_styles";

const BaseInput = forwardRef(
  ({ label, children, className = "", isActive = false, ...props }, ref) => {
    return (
      <div
        className={`relative ${className}`}
        data-testid="input-container"
        ref={ref}
        {...props}>
        {label && (
          <label
            className={getLabelClasses(isActive)}
            data-testid="input-label">
            {label}
          </label>
        )}
        {children}
      </div>
    );
  }
);

BaseInput.displayName = "BaseInput";

BaseInput.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  isActive: PropTypes.bool,
};

export default BaseInput;
